module.exports = __webpack_public_path__ + "img/72.108fc579.jpg";